<template>
    <kinesis-container class="home">
        <LoadingScreen></LoadingScreen>
        <SiteHeader></SiteHeader>
        <SiteIntro></SiteIntro>
        <CasesSlide></CasesSlide>
        <SiteFooter></SiteFooter>
    </kinesis-container>
</template>

<script>
// @ is an alias to /src
import SiteHeader from '@/components/SiteHeader.vue'
import SiteIntro from '@/components/SiteIntro.vue'
import CasesSlide from '@/components/CasesSlide.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import LoadingScreen from '@/components/LoadingScreen.vue'

export default {
  name: 'home',
  components: {
      SiteHeader,
      SiteIntro,
      CasesSlide,
      SiteFooter,
      LoadingScreen
  }
}
</script>
